import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { Header } from './components/common';

import Travel from './pages/travel/Travel';
import Mountainguide from './pages/mountainguide/Mountainguide';
import Avalanches from './pages/avalanches/Avalanches';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Terms from './pages/terms/Terms'
import Dsgvo from './pages/dsgvo/Dsgvo'
import Impressum from './pages/impressum/Impressum'
import Home from './pages/home/Home'
import Booking from './pages/booking/Booking'
import TermsMg from './pages/agb-bgf/agb-bgf'
import PRG from './pages/prg/PRG'
import BookingConfirmation from './pages/bookingConfirmation/BookingConfirmation'


const App = () => {
  return (
    <Router>
      <div className="App">
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/travel/offer" element={<Travel />} /* dummy URL when an offer is loaded */ />
          <Route path="/mountainguide" element={<Mountainguide />} />
          <Route path="/mountainguide/offer" element={<Mountainguide />} />
          <Route path="/avalanches" element={<Avalanches />} />
          <Route path="/avalanches/offer" element={<Avalanches />} />
          <Route path="/booking/:id" element={<Booking />} />
          <Route path="/confirmation" element={<BookingConfirmation />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dsgvo" element={<Dsgvo />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/agb-bgf" element={<TermsMg />} />
          <Route path="/prg" element={<PRG />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
